import { useCallback, useRef, useState } from 'react';

/**
 * Verrou action + modale « continuer » partagée (reprise automatique après save).
 */
export function useNr2jContinueAction() {
  const [continueReq, setContinueReq] = useState(null);
  const actionLockRef = useRef(false);

  const withActionLock = useCallback(async (fn) => {
    if (actionLockRef.current) return { skipped: true };
    actionLockRef.current = true;
    try {
      const result = await fn();
      return { skipped: false, result };
    } finally {
      actionLockRef.current = false;
    }
  }, []);

  const openContinue = useCallback((requirements, retryFn) => {
    setContinueReq({ requirements, retry: retryFn });
  }, []);

  const closeContinue = useCallback(() => {
    setContinueReq(null);
  }, []);

  const finishContinue = useCallback(async (saveFn, retryFn) => {
    const payload = await saveFn();
    setContinueReq(null);
    const run = retryFn || continueReq?.retry;
    if (run) {
      await run(payload);
    }
    return payload;
  }, [continueReq]);

  /** Reprise après save modale — ne pas ré-envelopper withActionLock (évite verrou imbriqué). */
  const runContinueRetry = useCallback(async (retryFn, payload) => {
    if (!retryFn) return undefined;
    return retryFn(payload);
  }, []);

  return {
    continueReq,
    openContinue,
    closeContinue,
    finishContinue,
    runContinueRetry,
    withActionLock,
    isActionLocked: () => actionLockRef.current,
  };
}
